<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row mu-w-100">

                    <h1 class="mu-mb-00">Custom data list</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">

                                {{ (isEditpage) ? helpTextEdit.title : helpTextCreate.title }}
                                <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>

            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Custom data list</a>
                    </li>
                    <li aria-current="page">{{(customDataList.id == 'new' || customDataList.id == null) ? 'Create new' : custmDataListName}}</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06 ">
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>

            <div v-show="fetchCall">
                <form id="customDataListForm" novalidate @submit.prevent="saveCustomDataList()">

                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-row">
                        <div class="mcc-col mcc-col-xs-6 mcc-col-md-6 mcc-col-sm-6">
                                <div class="mcc-card fullHeightCard">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Details</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mcc-row">
                                            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                    <label for="name" class="mfc-label--required">Name</label>
                                                    <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" ref="name" :value="customDataList.name" :pattern="nameRegex" @change="updateName($event)">

                                                </div>
                                                <div class="mfc-textarea-wrapper mfc-form-input-container">
                                                    <label for="description">Description</label>
                                                    <textarea id="description" name="description" maxlength="100" ref="description" placeholder="Description" :value="customDataList.description" :pattern="descRegex" @change="updateDescription($event)" @input="customDataList.description = $event.target.value" character-count=""></textarea>
                                                    <div class="mfc-invalid-feedback"></div>
                                                    <div class="mfc-help-text mu-mt-00">
                                                        <span class="mu-fs-xs">You have {{customDataList.description ? 100 - customDataList.description.length : 100}} characters remaining</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="mcc-col mcc-col-xs-6 mcc-col-md-6 mcc-col-sm-6">
                            <div class="mcc-card fullHeightCard">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Additional entries</h2>
                                </div>
                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col mcc-col-xs-12 mcc-col-md-6 mcc-col-sm-12">
                                            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                                <button class="mcc-button mcc-button--outline" type="button" id="addEntryBtn" @click="confirmOverwrite()" title="Add entry">
                                                    <mcc-icon name="add" aria-hidden="true"></mcc-icon><span class="mcc-button__label  mu-text-nowrap"> Add entry</span>
                                                </button>
                                                <button class="mcc-button mcc-button--outline" type="button" id="importEntriesBtn" @click="confirmOverwriteEsysData()" title="Import">
                                                    <mcc-icon name="import" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Import</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-row">
                                        <div class="mcc-col my-2">
                                            <mfc-row-repeater @ready="addRequiredClassToLabels()" v-show="showTable" ref="dataEntriesRR" id="customDataListEntries">
                                                <mfc-input type="text" name="nameField" id="dataFieldId" maxlength="50" label="Data field" dfAttr="dfAttr"></mfc-input>
                                                <mfc-input type="text" name="valueField" id="valueFieldId" maxlength="100" label="Value field" vfAttr="vfAttr"></mfc-input>
                                            </mfc-row-repeater>
                                            <div class="mcc-row" v-if="showURL">
                                                <div class="mcc-col my-2">
                                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                                        <label for="dataJson">External system URL / parameters</label>
                                                        <textarea id="dataJson" name="dataJson" readonly="" ref="dataJsonValue" :value="customDataList.dataJson" @change="customDataList.dataJson = $event.target.value"></textarea>
                                                        <div class="mfc-invalid-feedback"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mfc-input-wrapper mfc-form-input-container" hidden="">
                                                <input type="text" id="type" name="type" ref="dataListType" @change="customDataList.type = $event.target.value" :value="customDataList.dataJson ? 'eSys' : 'manual'">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mu-d-flex mu-justify-content-end mu-mt-05">
                        <router-link  :to="CONTEXT_PATH + '/design/customDataList'">
                            <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                            </button>
                        </router-link>
                        <button class="mcc-button mcc-button--success " title="Save" id="saveBtn" type="submit">
                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--md mcc-dialog--primary" data-bs-focus="false" data-height="450px" ref="assigneAdapterDialog" id="assigneAdapterDialog">
            <form novalidate id="formId" ref="formRef">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Import from adapter</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="dialogCloseEvent()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row" v-show="!fetchCallForImportData">
                            <div class="mcc-col colSpinner">
                                <div class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-row" v-show="fetchCallForImportData">
                            <div class="mcc-col">
                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Details</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mfc-slim-select-wrapper mfc-form-input-container mu-position-relative mu-mb-03">
                                            <div id="openESySelect"></div>
                                            <label for="assigneeESySelectCmp" class="mfc-label--required">External system</label>
                                            <select class="mfc-slim-select" autofocus id="assigneeESySelectCmp" name="assigneeESySelectCmp" block required @change="handleESysChangeEvent()">
                                                <option value=""></option>
                                            </select>
                                        </div>
                                        <div class="mfc-slim-select-wrapper mfc-form-input-container mu-position-relative mu-mb-03">
                                            <div id="openAPISelect"></div>
                                            <label for="assigneeAPISelectCmp" class="mfc-label--required">API</label>
                                            <select class="mfc-slim-select" id="assigneeAPISelectCmp" name="assigneeAPISelectCmp" block required @change="handleAPIChangeEvent()">
                                                <option value=""></option>
                                            </select>
                                        </div>
                                        <div class="mfc-slim-select-wrapper mfc-form-input-container mu-position-relative mu-mb-03">
                                            <div id="openAdapterSelect"></div>
                                            <label for="assigneeAdapterSelectCmp" class="mfc-label--required">Adapter</label>
                                            <select class="mfc-slim-select" id="assigneeAdapterSelectCmp" name="assigneeAdapterSelectCmp" block required @change="handleAdapterChangeEvent()">
                                                <option value=""></option>
                                            </select>
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="dataField">Data field</label>
                                            <input type="text" id="dataField" value="" name="dataField">
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="displayField">Display field</label>
                                            <input type="text" id="displayField" value="" name="displayField">
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="valueField">Value field</label>
                                            <input type="text" id="valueField" value="" name="valueField">
                                        </div>
                                        <div class="mfc-slim-select-wrapper mfc-form-input-container mu-position-relative mu-mb-03">
                                          <div id="openPaginationTypeSelect"></div>
                                          <label for="paginationType">Pagination Type</label>
                                          <select class="mfc-slim-select" id="paginationType" name="paginationType" v-model="paginationType">
                                            <option value="none">None</option>
                                            <option value="simple">Page, records per page</option>
                                            <option value="cursor">Records to skip, record to start from</option>
                                            <option value="cursorinfo">Cursor, limit</option>
                                          </select>
                                        </div>                                       <!-- Dynamic fields -->
                                        <div v-if="paginationType === 'simple'" class="mu-mt-02">
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="page">Page parameter</label>
                                            <input type="text" id="page" v-model="page" name="page">
                                          </div>
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="recordsPerPage">Records per page parameter</label>
                                            <input type="text" id="recordsPerPage" v-model="recordsPerPage" name="recordsPerPage">
                                          </div>
                                        </div>
                                        <div v-if="paginationType === 'cursor'" class="mu-mt-02">
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="recordsToSkip">Records to skip parameter</label>
                                            <input type="text" id="recordsToSkip" v-model="recordsToSkip" name="recordsToSkip">
                                          </div>
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="recordToStartFrom">Record to start from parameter</label>
                                            <input type="text" id="recordToStartFrom" v-model="recordToStartFrom" name="recordToStartFrom">
                                          </div>
                                        </div>
                                        <!-- Add this block alongside the other paginationType conditional blocks -->
                                        <div v-if="paginationType === 'cursorinfo'" class="mu-mt-02">
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="cursorParameter">Cursor parameter</label>
                                            <input type="text" id="cursorParameter" v-model="cursorParameter" name="cursorParameter" placeholder="e.g. cursor">
                                          </div>
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="nextCursorField">Next cursor returned field</label>
                                            <input type="text" id="nextCursorField" v-model="nextCursorField" name="nextCursorField" placeholder="e.g. nextCursor">
                                          </div>
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="maxRecordsParameter">Max records parameter</label>
                                            <input type="text" id="maxRecordsParameter" v-model="maxRecordsParameter" name="maxRecordsParameter" placeholder="e.g. limit">
                                          </div>
                                        </div>
                                        <!-- Add maxRecord field for any pagination type except none -->
                                        <div v-if="paginationType !== 'none'" class="mu-mt-02">
                                          <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="maxRecord">Max record</label>
                                            <input type="number" id="maxRecord" v-model="maxRecord" name="maxRecord" min="1">
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mcc-col mcc-col-xs-6 mcc-col-md-6 mcc-col-sm-6">
                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Parameter</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mcc-table--striped mcc-table--bordered mu-overflow-auto mu-mt-03" id="parametersTable" :hidden="!showParametersTable" hover="">
                                            <table id="paramsTable">
                                                <thead>
                                                    <tr>
                                                        <th>Parameter name</th>
                                                        <th>Parameter value</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="editableContent">
                                                    <tr v-for="(param,key) in paramsArr" :key="key" :id="'paramRow'+key">
                                                        <td>
                                                            <span>{{param.nameField}}</span>
                                                        </td>
                                                        <td>
                                                            <div class="mfc-input-wrapper mfc-form-input-container">
                                                                <input type="text" aria-label="paramValue" :id="'paramValue'+key" :name="'paramValue'+key" :value="param.valueField" @change="paramsArr[key].valueField = $event.target.value;">
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer mu-justify-content-end">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button class="mcc-button mcc-button--outline" id="resetDialogBtn" type="button" @click="resetDialog()"><span class="mcc-button__label">Reset</span></button>
                            <button class="mcc-button mcc-button--outline " id="testAdapterBtn" type="button" @click="testAdapter()"><span class="mcc-button__label">Test adapter</span></button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="importDataEntries()">Import</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="overwriteconfDialog" id="overwriteconfDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Overwrite data list</h2>
                    <button class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.overwriteconfDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">Do you want to overwrite the current list?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.overwriteconfDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--warning" @click="handleConfDialog()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import CustomDataListAPI from "../../../services/CustomDataListAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid';
export default {
    name: "CustomDataListCreate",

    data() {
        return {
            customDataList: {
                type: "manual",
                dataEntries: [],
                description: "",
            },
            emptyField: {
                "placeholder": true,
                "text": "",
                "value": ""
            },
            paginationType: 'none', // default value
            // add these properties to hold textbox values:
            maxRecord: 1,
            page: '',
            recordsPerPage: '',
            recordsToSkip: '',
            recordToStartFrom: '',
            cursorParameter: '',         // name of the cursor query parameter
            nextCursorField: '',         // response field that contains the next cursor
            maxRecordsParameter: '',     // name of the max records query parameter

            custmDataListName: "",
            updateCall: true,
            helpTextCreate: constantMessages.BREADCRUMB_HELP["design.customdatalist.create"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["design.customdatalist.edit"],
            fetchCall: false,
            fetchCallForImportData: true,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            showTable: false,
            showURL: false,
            showParametersTable: false,
            exteranlSystemData: [],
            apiData: [],
            adapterData: [],
            selectedConnectionType: "",
            paramsArr: [],
            isEditpage: false,
            assigneeESySelectCmpSlimInstance: null,
            assigneeAPISelectCmpSlimInstance: null,
            assigneeAdapterSelectCmpSlimInstance: null,
            isDescriptionValid: true,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.assigneeESySelectCmpSlimInstance = new SlimSelect({
            select: '#assigneeESySelectCmp',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('openESySelect')
            }
        })
        this.assigneeAPISelectCmpSlimInstance = new SlimSelect({
            select: '#assigneeAPISelectCmp',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('openAPISelect')
            }
        })
        this.assigneeAdapterSelectCmpSlimInstance = new SlimSelect({
            select: '#assigneeAdapterSelectCmp',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('openAdapterSelect')
            }
        })
        this.paginationTypeSlimInstance = new SlimSelect({
          select: '#paginationType',
          settings: {
            contentPosition: 'absolute',
            contentLocation: document.getElementById('openPaginationTypeSelect')
          }
        });
        let self = this;
        let dataListId = self.$route.params.dataListId;
        self.isEditpage = dataListId != null && dataListId != 'new';

        if (dataListId != "new") {
            let dataEntriesArr = [];
            CustomDataListAPI.getDataList(dataListId).then(response => {
                if (response != null) {
                    self.customDataList = response;
                    $.each(self.customDataList.dataEntries, function (i, val) {
                        let obj = {
                            "nameField": val.nameField,
                            "valueField": val.valueField
                        };
                        dataEntriesArr.push(obj);
                    });

                    self.custmDataListName = self.customDataList.name;
                    if (response.dataJson != "" && response.type == "eSys") {
                        self.showURL = true;
                    }

                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.design.dataList"] + " - " + self.custmDataListName;
                    EventBus.$emit("update-pageTitle", pageTitle);
                }
            }).finally(() => {
                if (self.dataListType === "manual" || self.customDataList.type === "manual") {
                    self.setRowRepeaterData(dataEntriesArr);
                } else {
                    self.fetchCall = true;
                }
            });
        } else {
            self.fetchCall = true;
        }
        this.setupMutationObserver()

    },
    methods: {
        setupMutationObserver() {
        const observer = new MutationObserver(() => {
            this.addRequiredClassToLabels();
        });

        const targetNode = this.$el.querySelector('#customDataListEntries');
        if (targetNode) {
            observer.observe(targetNode, { childList: true, subtree: true });
        }
    },
        addRequiredClassToLabels() {
        this.$nextTick(() => {
            const inputs = this.$el.querySelectorAll('mfc-input');
            
            if (!inputs.length) {
                return;
            }
            
            inputs.forEach(input => {
                const label = input.querySelector('label');
                
                if (label) {
                    if (input.getAttribute('name') === 'nameField-rr-0' || input.getAttribute('name') === 'valueField-rr-0') {
                        label.classList.add('mfc-label--required');
                    }
                }
            });
        });
    },
        dialogCloseEvent() {
            let form = $('#formId')

            form[0].classList.remove("ms-was-validated")
            $("#assigneAdapterDialog")[0].close();
            this.resetDialog();
        },
        bindChangeEvent() {
            let self = this;
            $(".mcc-row-repeater [dfAttr=dfAttr]").off("change").on("change", function (e) {
                self.updateDataField(e);
            });
            $(".mcc-row-repeater [vfAttr=vfAttr]").off("change").on("change", function (e) {
                self.updateValueField(e);
            });
        },

        updateCurrentStatusOfDataField() {
            let self = this;
            let alldataFields = $("[dfAttr=dfAttr]");
            $.each(alldataFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForDataField(df, dataVal);
            });
        },
        updatecurrentStatusOfValueField() {
            let self = this;
            let allValueFields = $("[vfAttr=vfAttr]");
            $.each(allValueFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForValueField(df, dataVal);
            });
        },
        performValidationsForValueField(component, dataVal) {
            let valid = true
            let pattern = new RegExp(this.descRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.valueField.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (dataVal.length > 100) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.valueField.maxlength"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.valueField.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (!Utils.isPropertyValid("vfAttr", "error.valueField.unique")) {
                valid = false
            } else {
                Utils.removeExistingMessages("vfAttr", this.descRegex, 100);
                component[0].classList.remove("ms-is-invalid")
                valid = true
            }
            return valid
        },
        performValidationsForDataField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.nameRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.dataField.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (dataVal.length > 50) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.dataField.maxlength"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.dataField.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false
            } else if (!Utils.isPropertyValid("dfAttr", "error.dataField.unique")) {
                valid = false
            } else {
                Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true
            }
            return valid;
        },
        setRowRepeaterData(dataEntriesArr) {
            let self = this;
            if (dataEntriesArr.length > 0) {
                self.showTable = true;
                setTimeout(() => {
                    self.$refs.dataEntriesRR.setData(dataEntriesArr, {});
                    setTimeout(() => {
                        self.bindChangeEvent();
                    }, 1000);

                }, 1000);
            }
            self.fetchCall = true;
        },
        saveCustomDataList() {
            let self = this;
            let form = $('#customDataListForm')
            let formInvalid = false;
            if(!self.isDescriptionValid){
                return;
            }
            if (this.customDataList.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form)){
                    formInvalid = true;
                    if(!self.showTable)
                    return;
                }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }   
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }    
            

            let dataListId = "new";
            if (self.customDataList.id != undefined) {
                dataListId = self.customDataList.id;
            }
            let nameFieldComp;
            let nameFieldValue;
            let valueFieldComp;
            let valueFieldvalue;

            if (self.showTable) {
                self.customDataList.dataEntries = [];
                let isValidDataField = true;
                let isValidValField = true;
                let isValidRow = true
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=nameField]");
                    nameFieldValue = $(nameFieldComp).val();
                    valueFieldComp = $(row).find("input[name^=valueField]");
                    valueFieldvalue = $(valueFieldComp).val();
                    if ($(nameFieldComp)[0].name !== 'nameField-rr-0') {
                        isValidDataField = self.performValidationsForDataField(nameFieldComp, nameFieldValue);
                    }
                    if ($(valueFieldComp)[0].name !== 'valueField-rr-0') {
                        isValidValField = self.performValidationsForValueField(valueFieldComp, valueFieldvalue)
                    }

                    if (!isValidDataField || !isValidValField) {
                        isValidRow = false
                    }
                })
                if (!isValidRow || formInvalid) {
                    return;
                }
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=nameField]");
                    nameFieldValue = $(nameFieldComp).val();

                    valueFieldComp = $(row).find("input[name^=valueField]");
                    valueFieldvalue = $(valueFieldComp).val();
                    let obj = {
                        "nameField": nameFieldValue,
                        "valueField": valueFieldvalue
                    };
                    self.customDataList.dataEntries.push(obj);
                })
                self.customDataList.dataEntries.shift()
            }
            self.updateCall = false;
            CustomDataListAPI.saveCustomDataList(
                self.customDataList,
                dataListId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.customDataList = response.data;
                    self.custmDataListName = response.data.name;
                    let entriesArr = [];
                    if (response.data.type == "manual" && response.data.dataEntries.length > 0) {
                        $.each(response.data.dataEntries, function (i, val) {
                            let obj = {
                                "nameField": val.nameField,
                                "valueField": val.valueField
                            };
                            entriesArr.push(obj);
                        });
                        self.showTable = true;
                    }
                    if (self.$refs.dataEntriesRR != undefined && entriesArr.length > 0) {
                        setTimeout(() => {
                            self.$refs.dataEntriesRR.values = entriesArr;
                        }, 0);
                    } else {
                        self.showTable = false;
                    }

                    if (!self.isEditpage) {
                        self.$router
                            .push(
                                self.CONTEXT_PATH + "/design/customDataList/" + response.data.id);
                    }
                }
            });
        },
        redirectToList() {
            localStorage.setItem("customDataList", "customDataList");
            this.$router.push(this.CONTEXT_PATH + "/design/customDataList");
        },
        addEntry() {
            let self = this;
            self.$refs.dataListType.value = "manual";
            self.customDataList.type = "manual";
            self.showTable = true;
            let arr = [];
            arr.push({
                "nameField": "",
                "valueField": ""
            });
            $("#customDataListEntries").css("display", "block");
            setTimeout(() => {
                self.$refs.dataEntriesRR.values = arr;
                self.handleAddrowEventForRowRepeater();
            }, 0);
        },
        handleAddrowEventForRowRepeater() {
            let self = this;
            self.$refs.dataEntriesRR.addEventListener("add", function (e) {
                setTimeout(() => {
                    self.bindChangeEvent();
                }, 1000);
            });
            self.$refs.dataEntriesRR.addEventListener("remove", function (e) {
                setTimeout(() => {
                    Utils.removeExistingMessages("vfAttr", this.descRegex, 100);
                    Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
                }, 100);
            });
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.customDataList.description = event.target.value;
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.customDataList.name = event.target.value;
        },
        updateDataField(event) {
            this.performValidationsForDataField(event.target, event.target.value);
        },
        updateValueField(event) {
            this.performValidationsForValueField(event.target, event.target.value);
        },
        confirmOverwrite() {
            let type = this.$refs.dataListType.value;
            if (this.customDataList.dataJson !== "" && type === "eSys") {
                $("#overwriteconfDialog")[0].show();
            } else {
                this.addEntry();
            }
        },
        confirmOverwriteEsysData() {
            let self = this;
            let dataEntriesCount =  $(".mcc-row-repeater .mcc-row-repeater__row").filter(function() {
                return $(this).parent().is(':visible');
            }).length;
            let type = this.$refs.dataListType.value;
            if (dataEntriesCount > 0 && type == "manual") 
            {
                $("#overwriteconfDialog")[0].show();
            } else {
                this.openImportDialog();
            }
        },
        handleConfDialog(e) {
            let type = this.$refs.dataListType.value;
            $("#overwriteconfDialog")[0].close();
            if (type == "manual") {
                $("#customDataListEntries").css("display", "none");
                $(".mcc-row-repeater").each(function() {
                    $(this).find(".mcc-row-repeater__row").not(":first").remove();
                });
                this.showTable = false;
                this.customDataList.dataEntries = [];
                this.openImportDialog();
            } else {
                $("#dataJson").val("");
                this.showURL = false;

                this.customDataList.dataJson = "";
                $("#dataJson").attr("hidden", true);
                this.customDataList.dataEntries = [];
                this.addEntry();
            }

        },
        openImportDialog() {
            let self = this;
            CustomDataListAPI.getExternalSystemsData().then(response => {
                let es = [];
                self.exteranlSystemData = response.data;
                es.push(self.emptyField);

                $.each(self.exteranlSystemData, function (i, eSys) {
                    let obj = {
                        "text": eSys.name,
                        "value": eSys.name
                    };
                    es.push(obj);
                });
                this.assigneeESySelectCmpSlimInstance.setData(es);

                if (
                    self.customDataList.dataJson != "" &&
                    self.customDataList.type == "eSys"
                ) {
                    self.fetchCallForImportData = true;
                    setTimeout(() => {
                        let dataJson = JSON.parse(self.customDataList.dataJson);
                        // Add this line to populate paginationType from imported data
                        if (dataJson.paginationParameter) {
                            self.paginationType = dataJson.paginationParameter.paginationType;
                            // Optionally also restore page/recordsPerPage/etc if present
                            if (dataJson.paginationParameter.page) self.page = dataJson.paginationParameter.page;
                            if (dataJson.paginationParameter.recordsPerPage) self.recordsPerPage = dataJson.paginationParameter.recordsPerPage;
                            if (dataJson.paginationParameter.recordsToSkip) self.recordsToSkip = dataJson.paginationParameter.recordsToSkip;
                            if (dataJson.paginationParameter.recordToStartFrom) self.recordToStartFrom = dataJson.paginationParameter.recordToStartFrom;
                            if (dataJson.paginationParameter.maxRecord) self.maxRecord = dataJson.paginationParameter.maxRecord;
                            if (dataJson.paginationParameter.cursorParameter) this.cursorParameter = dataJson.paginationParameter.cursorParameter;
                            if (dataJson.paginationParameter.nextCursorField) this.nextCursorField = dataJson.paginationParameter.nextCursorField;
                            if (dataJson.paginationParameter.maxRecordsParameter) this.maxRecordsParameter = dataJson.paginationParameter.maxRecordsParameter;

                        } else {
                            self.paginationType = 'none'; // fallback default
                        }

                        // Set initial value if exists
                        if (self.customDataList.dataJson) {
                            const dataJson = JSON.parse(self.customDataList.dataJson);
                            if (dataJson.paginationParameter && dataJson.paginationParameter.paginationType) {
                                self.paginationType = dataJson.paginationParameter.paginationType;
                                self.paginationTypeSlimInstance.setSelected(self.paginationType);
                            }
                        }

                        let eSystem = dataJson.eSystem;
                        this.assigneeESySelectCmpSlimInstance.setSelected(eSystem)
                        $("#dataField").val(dataJson.dataField);
                        $("#displayField").val(dataJson.dispField);
                        $("#valueField").val(dataJson.valueField);
                        self.handleESysChangeEvent();
                    }, 100);

                }
            });
            $("#assigneAdapterDialog")[0].show();
        },
        resetSlimSelect() {
            this.assigneeESySelectCmpSlimInstance.setSelected('')
            this.assigneeAPISelectCmpSlimInstance.setSelected('')
            this.assigneeAdapterSelectCmpSlimInstance.setSelected('')
        },
        resetDialog() {

            this.resetParametersGrid();
            $("#dataField").val($("#dataField").val());
            $("#dataField").val("");
            $("#displayField").val($("#displayField").val());
            $("#displayField").val("");
            $("#valueField").val($("#valueField").val());
            $("#valueField").val("");
            this.resetSlimSelect()
        },
        testAdapter() {
            let importForm = $("#assigneAdapterDialog form");
            if (!importForm[0].checkValidity()) {
                handleFormValidation(importForm, validationMessages);
                // importForm.showErrors();
                return;
            }
            let url = this.generateServiceURL();
            CustomDataListAPI.testAdapter(url).then(response => {
                if (response != undefined) {
                    if (typeof response.data == "object") {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[
                                "customDataList.importDialog.testAdapter.success"
                            ]
                        });
                    } else if (typeof response.data == "string") {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[
                                "customDataList.importDialog.testAdapter.error"
                            ]
                        });
                    }
                }
            });
        },
        handleESysChangeEvent() {
            let self = this;
            this.assigneeAPISelectCmpSlimInstance.setData([self.emptyField]);
            this.assigneeAdapterSelectCmpSlimInstance.setData([self.emptyField]);
            self.resetParametersGrid();
            let eSystem = $("#assigneeESySelectCmp").val();
            if (eSystem != "") {
                $.each(self.exteranlSystemData, function (ind, eSysVal) {
                    if (eSystem == eSysVal.name) {
                        CustomDataListAPI.getAPIsData(eSysVal.id).then(result => {
                            if (result != null) {
                                self.insertAPIs(result.data);
                            }
                        });
                    }
                });
            }
        },
        insertAPIs(apisData) {
            let self = this;
            let apis = [];
            apis.push(self.emptyField);
            $.each(apisData, function (i, value) {
                self.apiData = apisData;

                let obj = {
                    text: value.name,
                    value: value.name
                };
                apis.push(obj);
            });
            this.assigneeAPISelectCmpSlimInstance.setData(apis);

            if (
                self.customDataList.dataJson != "" &&
                self.customDataList.type == "eSys"
            ) {
                let dataJson = JSON.parse(self.customDataList.dataJson);
                let eAPI = dataJson.eAPI;
                setTimeout(() => {
                    this.assigneeAPISelectCmpSlimInstance.setSelected(eAPI);
                    self.handleAPIChangeEvent();
                }, 100);
            }
        },
        handleAPIChangeEvent() {
            let self = this;
            this.assigneeAdapterSelectCmpSlimInstance.setData([self.emptyField]);
            self.resetParametersGrid();
            let eSystem = $("#assigneeESySelectCmp").val();
            let eAPI = $("#assigneeAPISelectCmp").val();

            if (eSystem != "" && eAPI != "") {
                $.each(self.apiData, function (ind, apiVal) {
                    if (eAPI == apiVal.name) {
                        self.selectedConnectionType = apiVal.connectionType;
                        CustomDataListAPI.getAdaptersData(apiVal.id, apiVal.connectionType).then(result => {
                            if (result != null) {
                                self.adapterData = result.data;
                                self.insertAdapters(result.data);
                            }
                        });
                    }
                });
            }
        },
        insertAdapters(adaptersData) {
            let self = this;
            let eAdapts = [];

            eAdapts.push(self.emptyField);
            $.each(adaptersData, function (i, value) {

                let obj = {
                    text: value.name,
                    value: value.name
                };
                eAdapts.push(obj);
            });
            this.assigneeAdapterSelectCmpSlimInstance.setData(eAdapts);

            if (
                self.customDataList.dataJson != "" &&
                self.customDataList.type == "eSys"
            ) {
                let dataJson = JSON.parse(self.customDataList.dataJson);
                let eAdapter = dataJson.eAdapter;
                setTimeout(() => {
                    this.assigneeAdapterSelectCmpSlimInstance.setSelected(eAdapter)
                    self.handleAdapterChangeEvent();
                }, 100);
            }
        },
        handleAdapterChangeEvent() {
            this.resetParametersGrid();
            this.showParameters();
        },
        resetParametersGrid() {
            this.paramsArr = [];
            this.showParametersTable = false;
        },
        showParameters() {
            let self = this;
            let eAdapter = $("#assigneeAdapterSelectCmp").val();
            let dataJson = self.customDataList.dataJson;
            let dataJsonObj = (dataJson != "" && dataJson != undefined) ? JSON.parse(dataJson) : "";

            if (dataJsonObj != "" && dataJsonObj.eAdapter == eAdapter) {
                let params = dataJsonObj.parameters;
                self.populateparametersTable(params, true);
            } else {
                if (eAdapter !== "") {
                    $.each(self.adapterData, function (ind, adapterVal) {
                        if (eAdapter == adapterVal.name) {
                            CustomDataListAPI.getParametersData(adapterVal.id, self.selectedConnectionType).then(result => {
                                if (result != null) {
                                    self.populateparametersTable(result, false);
                                }
                            });
                        }
                    });
                }
            }
        },
        populateparametersTable(parametersData, isFromEdit) {
            let self = this;

            if (parametersData && parametersData.length > 0) {
                self.showParametersTable = true;
                if (!isFromEdit) {
                    $.each(parametersData, function (i, value) {
                        self.paramsArr.push({
                            nameField: value.paramName,
                            valueField: ""
                        });
                    });
                } else {
                    $.each(parametersData, function (i, value) {
                        self.paramsArr.push({
                            nameField: value.nameField,
                            valueField: value.valueField
                        });
                        self.showParametersTable = true;
                    });
                }
                self.showParametersTable = true;
            }
            setTimeout(() => {
                self.fetchCallForImportData = true;
            }, 0);
        },
        importDataEntries() {
            let form = $('#formId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            form[0].classList.remove("ms-was-validated")
            let self = this;

            let url = self.generateServiceURL();
            let eSystem = $("#assigneeESySelectCmp").val();
            let eAPI = $("#assigneeAPISelectCmp").val();
            let eAdapter = $("#assigneeAdapterSelectCmp").val();
            let dataField = $("#dataField").val();
            let valueField = $("#valueField").val();
            let dispField = $("#displayField").val();
            if (dataField == null || dataField == "") {
                dataField = "data";
            }
            if (dispField == null || dispField == "") {
                dispField = "value";
            }
            if (valueField == null || valueField == "") {
                valueField = "name";
            }
            let dataJsonObj = {
                url: url,
                eSystem: eSystem,
                eAPI: eAPI,
                eAdapter: eAdapter,
                dataField: dataField,
                valueField: valueField,
                dispField: dispField,
                parameters: self.paramsArr,
                paginationParameter:{}
            };

            // Build paginationParameter based on paginationType
            if (this.paginationType === "simple") {
              dataJsonObj.paginationParameter = {
                paginationType: "simple",
                page: this.page,
                recordsPerPage: this.recordsPerPage,
                maxRecord: this.maxRecord
              };
            } else if (this.paginationType === "cursor") {
              dataJsonObj.paginationParameter = {
                paginationType: "cursor",
                recordsToSkip: this.recordsToSkip,
                recordToStartFrom: this.recordToStartFrom,
                maxRecord: this.maxRecord
              };
            } else if (this.paginationType === 'cursorinfo') {
                dataJsonObj.paginationParameter = {
                  paginationType: 'cursorinfo',
                  cursorParameter: this.cursorParameter,
                  nextCursorField: this.nextCursorField,
                  maxRecordsParameter: this.maxRecordsParameter,
                  maxRecord: this.maxRecord
                };
            } else {
              dataJsonObj.paginationParameter = {}; // or omit this field
            }

            self.showURL = true;
            self.customDataList.dataJson = JSON.stringify(dataJsonObj);
            if (self.$refs.dataJsonValue != undefined) {
                self.$refs.dataJsonValue.value = JSON.stringify(dataJsonObj);
            }
            self.$refs.dataListType.value = "eSys";
            self.customDataList.type = "eSys";
            $("#dataJson").removeAttr("hidden");
            self.dialogCloseEvent();
        },
        generateServiceURL() {
            let eSystem = $("#assigneeESySelectCmp").val();
            let eAPI = $("#assigneeAPISelectCmp").val();
            let eAdapter = $("#assigneeAdapterSelectCmp").val();
            let url = "/adapters/" + eSystem + "/" + eAPI + "/" + eAdapter;

            $.each(this.paramsArr, function (i, value) {
                let paramName = value.nameField;
                let paramValue = value.valueField;
                if (paramName != "" && paramValue != "") {
                    if (i == 0) {
                        url = url + "?" + paramName + "=" + paramValue;
                    } else {
                        url = url + "&" + paramName + "=" + paramValue;
                    }
                }
            });
            return url;
        }
    }
};
</script>
